import RoomFacilitiesList from './RoomFacilitiesList';
export default RoomFacilitiesList;